const info = {
  // onLocation: {
  //   ua: "Хмельницький",
  //   en: "",
  // },
  // city: {
  //   ua: "Хмельницький",
  //   en: "",
  // },
  // street: {
  //   ua: "Соборна, 16",
  //   en: "",
  // },
  // tel: {
  //   text: "099 33 56 296",
  //   number: "tel:0993356296",
  // },
  // telegram: "https://t.me/+380993356296",
  // viber: "viber://add?number=380993356296",
  // instagram: "",
  // schedule: {
  //   weekdays: "10:00-20:00",
  //   weekend: "10:00-20:00",
  // },

  // mapPoint:
  //   "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d162.18697838544364!2d26.9810732!3d49.4279718!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473207ab35769a77%3A0x671fd1ea113c4786!2zQ29tcC1TZXJ2aWNlIC0g0KDQtdC80L7QvdGCINC60L7QvNC_J9GO0YLQtdGA0ZbQsiDRgtCwINC90L7Rg9GC0LHRg9C60ZbQsiDQpdC80LXQu9GM0L3QuNGG0YzQutC40Lk!5e0!3m2!1sru!2sua!4v1744836981668!5m2!1sru!2sua",
  // mapWay: "https://maps.app.goo.gl/DMFBEqLSaAMF53n6A",

  onLocation: {
    ua: "Софіївська Борщагівка",
    en: "Sofiivska Borshchahivka",
  },
  city: {
    ua: "с. Софіївська Борщагівка",
    en: "Sofiivska Borshchahivka",
  },
  street: {
    ua: "пр-т Героїв Небесної Сотні, 18/1",
    en: "Heroiv Nebesnoi Sotni Ave, 18/1",
  },
  tel: {
    text: "050 506 85 42",
    number: "tel:0505068542",
  },
  tel2: {
    text: "098 506 85 42",
    number: "tel:0985068542",
  },
  telegram: "https://t.me/+380985068542",
  viber: "viber://add?number=380505068542",
  instagram: "https://www.instagram.com/rem_komp_ukvartal/?hl=en",
  schedule: {
    weekdays: "8:00-21:00",
    weekend: "8:00-21:00",
  },
  mapPoint:
    "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7598.2325317302675!2d30.335456595997517!3d50.3949783098026!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cbb35df741ff%3A0x24406cbfcb558282!2zUi1TRVJWSUNFLdCg0LXQvNC-0L3RgiDQutC-0LzQvyfRjtGC0LXRgNGW0LIg0YLQsCDQvdC-0YPRgtCx0YPQutGW0LIg0KHQvtGE0ZbRl9Cy0YHRjNC60LAg0JHQvtGA0YnQsNCz0ZbQstC60LA!5e0!3m2!1sru!2sua!4v1708602250406!5m2!1sru!2sua",
  mapWay: "https://maps.app.goo.gl/MVzNegWutrfwJcoG7",
}

export default info
